var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 18.85" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "icon_mustle"
    ),
    React.createElement(
      "g",
      { id: "\u30EC\u30A4\u30E4\u30FC_2", "data-name": "\u30EC\u30A4\u30E4\u30FC 2" },
      React.createElement(
        "g",
        { id: "area_record" },
        React.createElement(
          "g",
          { id: "item_icon" },
          React.createElement(
            "g",
            { id: "icons_mustle" },
            React.createElement(
              "g",
              { id: "icon_mustle13" },
              React.createElement("path", { id: "item_mustle", className: styles["cls-1"] || "cls-1", d: "M0 9.28c1.79-.14 2 .65 3.09.81a5.49 5.49 0 0 1 3.25-.47c1.15.14 1.65.55 3.44 1.74a7.91 7.91 0 0 1 .13-1.48c.21-1.12.51-2.89.75-4 .09-.42 0-1 0-1.53-.62.19-1.11-.09-1.61 0a2.17 2.17 0 0 1-.87.1.69.69 0 0 1-.59-.74 2 2 0 0 0-.39-1.24.84.84 0 0 1 0-1.17 6.81 6.81 0 0 0 .67-.88C8.06 0 8.33 0 8.74 0c1.48 0 2.31 1 3.15 1.23a1.55 1.55 0 0 1 .94 1.14 17.46 17.46 0 0 0 2.3 6.53 7.89 7.89 0 0 1 .87 4.36 7 7 0 0 0-.15 1.12 12.34 12.34 0 0 0 0 1.36 1.94 1.94 0 0 1-1.54 1.85 5.31 5.31 0 0 0-1.22.3 18.32 18.32 0 0 1-7.78.85c-2.13-.26-3.54-1.52-5.13-1.52 0 0 .1-.63.19-2.32A28.48 28.48 0 0 0 0 9.28z" })
            )
          )
        )
      )
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/atoms/iconStroke/images/muscle.svg
// module id = 1643
// module chunks = 0